// @ts-nocheck
/**
 * TOMI NOVO — abre o visualizador de zoom (PhotoSwipe) portado do tema
 * Impulse. Reescrito em JS moderno (sem o polyfill jQuery-like `.on()` do
 * tema antigo), mas a lógica de montagem da galeria/opções é a mesma de
 * theme.Photoswipe (tema-antigo/assets/theme.js).
 *
 * Depende de assets/tomi-photoswipe.min.js (carregado como script clássico,
 * SEM type="module", já que expõe window.PhotoSwipe / window.PhotoSwipeUI_Default
 * via UMD checando `this` no escopo top-level).
 */

/**
 * @param {HTMLElement} button
 */
function handleZoomButtonClick(button) {
  const gallery = button.closest('[data-tomi-zoom-gallery]');
  if (!gallery) return;

  const images = Array.from(gallery.querySelectorAll('.photoswipe__image'));
  if (!images.length) return;

  const items = images.map((el) => ({
    msrc: el.currentSrc || el.src,
    // TOMI: Shopify's image_tag filter passes unrecognized keyword args
    // through VERBATIM as attribute names — data_photoswipe_src becomes the
    // literal attribute "data_photoswipe_src" (underscores), not the
    // kebab-case "data-photoswipe-src" a hand-written data-* attribute would
    // use. getAttribute must match that exact literal name.
    src: el.getAttribute('data_photoswipe_src'),
    w: parseInt(el.getAttribute('data_photoswipe_width'), 10) || 0,
    h: parseInt(el.getAttribute('data_photoswipe_height'), 10) || 0,
    el,
    initialZoomLevel: 0.5,
  }));

  // TOMI NOVO: o botão agora é ÚNICO e fixo (não um por slide) — o índice é
  // lido em tempo real do slideshow-component (sua imagem/foto ATUAL), em
  // vez de vir gravado num data-index fixo no botão.
  const component = gallery.querySelector('slideshow-component');
  const currentIndex = component && typeof component.current === 'number' ? component.current : 0;

  openGallery(items, currentIndex);
}

/**
 * @param {{msrc: string, src: string, w: number, h: number, el: HTMLElement}[]} items
 * @param {number} index
 */
function openGallery(items, index) {
  const pswpElement = document.querySelectorAll('.pswp')[0];
  if (!pswpElement || typeof window.PhotoSwipe === 'undefined' || typeof window.PhotoSwipeUI_Default === 'undefined') {
    return;
  }

  const options = {
    allowPanToNext: false,
    captionEl: false,
    closeOnScroll: false,
    counterEl: false,
    history: false,
    index,
    pinchToClose: false,
    preloaderEl: false,
    // TOMI CONSERTO: 'zoom' abre a imagem em 100% do tamanho real do
    // ARQUIVO (não da tela) sempre que esse tamanho for MAIOR que a área
    // visível — como as fotos do produto têm resoluções bem diferentes
    // entre si, algumas abriam already "estouradas"/com zoom alto e outras
    // normais, de forma inconsistente. 'fit' sempre encaixa a imagem
    // inteira na área visível ao abrir, do mesmo jeito pra qualquer foto —
    // dar zoom (clique/duplo toque/pinça) continua funcionando normalmente
    // a partir desse tamanho.
    scaleMode: 'fit',
    shareEl: false,
    tapToToggleControls: false,
    getThumbBoundsFn(i) {
      const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
      const thumbnail = items[i].el;
      const rect = thumbnail.getBoundingClientRect();
      return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
    },
  };

  const gallery = new window.PhotoSwipe(pswpElement, window.PhotoSwipeUI_Default, items, options);
  gallery.init();
  preventiOS15Scrolling(gallery);
  hideHeaderWhileOpen(gallery);
}

/**
 * TOMI NOVO — esconde o cabeçalho (desktop) enquanto o zoom está aberto, pra
 * não tirar o foco do cliente e não sobrepor/cortar a imagem ampliada. Some
 * assim que abre, volta assim que fecha (evento "destroy" do PhotoSwipe =
 * dialog já totalmente fechado, incluindo a animação de retorno).
 * @param {any} gallery
 */
function hideHeaderWhileOpen(gallery) {
  document.documentElement.classList.add('tomi-zoom-header-hidden');
  gallery.listen('destroy', () => {
    document.documentElement.classList.remove('tomi-zoom-header-hidden');
  });
}

/**
 * Fix poached from https://gist.github.com/dimsemenov/0b8c255c0d87f2989e8ab876073534ea
 * @param {any} gallery
 */
function preventiOS15Scrolling(gallery) {
  if (!/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) return;

  const syncHeight = () => {
    document.documentElement.style.setProperty('--window-inner-height', `${window.innerHeight}px`);
  };

  syncHeight();
  const initialScrollPos = window.scrollY;
  document.documentElement.classList.add('pswp-open-in-ios');
  window.addEventListener('resize', syncHeight);

  gallery.listen('destroy', () => {
    document.documentElement.classList.remove('pswp-open-in-ios');
    window.removeEventListener('resize', syncHeight);
    window.scrollTo(0, initialScrollPos);
  });
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof Element ? event.target.closest('.tomi-zoom-button') : null;
  if (button) handleZoomButtonClick(button);
});
